import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'moment';

function ToastMessage(props) {
  var children = props.children,
    content = props.content,
    className = props.className;
  var xPosition = props.xPosition,
    yPosition = props.yPosition,
    type = props.type;
  var allowedXPosition = ['left', 'center', 'right'];
  xPosition = allowedXPosition.some(function (validPosition) {
    return validPosition === xPosition;
  }) ? "bf-toast-x-position-".concat(xPosition) : '';
  var allowedYPosition = ['top', 'bottom'];
  yPosition = allowedYPosition.some(function (validPosition) {
    return validPosition === yPosition;
  }) ? "bf-toast-y-position-".concat(yPosition) : '';
  var allowedType = ['warning', 'danger', 'error', 'success', 'negative', 'neutral'];
  type = allowedType.some(function (validType) {
    return validType === type;
  }) ? "bf-toast-".concat(type) : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-toast-wrapper ".concat(xPosition, " ").concat(yPosition)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-toast ".concat(type, " ").concat(className)
  }, children || content));
}
ToastMessage.defaultProps = {
  xPosition: 'right',
  yPosition: 'bottom',
  type: 'neutral',
  children: null,
  content: null,
  className: ''
};
ToastMessage.propTypes = {
  /**
  Horizontal position (left, center, right)
   */
  xPosition: PropTypes.string,
  /**
  Vertical position (left, center, right)
   */
  yPosition: PropTypes.string,
  /**
  Toast type (warning, danger, error, success, negative, neutral)
   */
  type: PropTypes.string,
  /**
  Toast content
   */
  children: nodeOrStringProp,
  /**
  Toast content
   */
  content: nodeOrStringProp,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default ToastMessage;
//# sourceMappingURL=Toast.js.map
